module.exports = __webpack_public_path__ + "static/bus-55c4879fd8f61777b0c858a9130acdd1.webp";